import React from "react";
import "./videoInterview.scss";

const VerificationPage = ({ code, onChange, onSubmit, validating, logoSrc }) => (
  <div className="verification-container">
    <div className="verification-holder">
      {logoSrc && <img src={logoSrc} alt="" width={160} height={80} className="verification-logo" />}
      <h2>Please enter your verification code</h2>
      <input
        type="text"
        value={code}
        onChange={onChange}
        placeholder="Enter code"
      />
      <button onClick={onSubmit} disabled={validating}>
        {validating ? "Verifying..." : "Submit"}
      </button>
    </div>
  </div>
);

export default VerificationPage;
